export default {
    stickers: {
        title: 'Aufkleber',
        stickerOpacity: 'Stickertransparenz',
        stickerColor: 'Aufkleberfarbe',
        shapes: {
            title: 'Formen',
            rectangle: 'Rechteck',
            circle: 'Kreis',
            triangle: 'Dreieck',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
